"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Root = styled_components_1.default.fieldset(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  border: none;\n"], ["\n  margin: 0;\n  padding: 0;\n  border: none;\n"])));
var templateObject_1;
//# sourceMappingURL=root.js.map